import * as loomEmbed from "@loomhq/loom-embed";
import { allVideoIds, buildLoomShareUrl } from "./learning-center-data";
import { LearningCenterVideo } from "./learning-center.store";

export const learningCenterApi = {
  loadVideos: async () => {
    const promises = allVideoIds.map((videoId) =>
      loomEmbed
        .oembed(buildLoomShareUrl(videoId))
        .then((v) => ({
          status: "fulfilled" as const,
          video: {
            id: videoId,
            title: v.title,
            duration: v.duration,
            thumbnailUrl: v.thumbnail_url,
            height: v.height,
            width: v.width,
          },
        }))
        .catch((error) => ({
          status: "rejected" as const,
          videoId,
          error,
        }))
    );

    const results = await Promise.all(promises);
    const successfulVideos = results
      .filter(
        (
          result
        ): result is { status: "fulfilled"; video: LearningCenterVideo } =>
          result.status === "fulfilled"
      )
      .map((result) => result.video);

    return successfulVideos;
  },
};
